<template>
  <div >
    <el-form class="search-box" style="height: 50px;line-height: 50px" >
      <div >作废列表</div>
    </el-form>

    <template v-for="item of items">
      <div class="show" :class="{'not_click':(item.status == 4||item.status == 5) }" :key="item.id"   @click="item.status != 4 && item.status != 5 && select(item)">
        <div class="line">
          <el-row>


            <el-col :span="12">
              <div class="grid-content bg-purple"
                   style="color: #bd2c00">
                <h3>订单编号</h3>
                <p>{{ item.order_number }}</p>
                <h3>货架号: </h3>
                <p>{{ item.shelf.shelf_no }}</p>
                <h3>多品编号</h3>
                <p>{{ item.transaction_number }}</p>
                <h3>数量</h3>
                <p style="color:  #bd2c00">{{ item.quantity }}</p>
              </div>
            </el-col>
            <el-col :span="12">
              <img style="width: 100%;" :src="item.image_url" alt="" preview="1" preview-text='图片展示'/>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <h3>SKU</h3>
                <p>{{ item.sku }}</p>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <h3>商品中文名称</h3>
                <p>{{ item.product_name }}</p>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="grid-content bg-purple-light">
                <p><span style="font-weight: bold">定制文案</span>: <span style="color: red">{{ item.word }}</span></p>
              </div>
            </el-col>
            <el-col :span="24" v-if="item.remark!==null">
              <div class="grid-content bg-purple-light">
                <p>备注: {{ item.remark }}</p>
              </div>
            </el-col>
            <el-col :span="24">
              <button class="cancel_btn" @click="cancel(item.id,item.shelf.shelf_no)">作废</button>
            </el-col>
          </el-row>
        </div>
      </div>
    </template>
    <template v-if="items.length<=0">
      <div>暂无数据</div>
    </template>
    <el-dialog
        title="提示"
        :visible.sync="centerDialogVisible"
        width="90%"
        top="30vh"
        :close-on-click-modal="false"
        :before-close="cancelDialog"
        center>
      <el-form class="search-box" ref="shelfForm" :model="shelfForm" :rules="rules">
        <el-form-item prop="shelf_number">
          <el-input
              ref="shelfSearch"
              @focus="stopKeyborad"
              @blur="stopKeyborad"
              v-model="shelfForm.shelf_number"
              @keydown.enter.native.prevent="doCancel()"
              :placeholder="placeholderInfo"
          >
            <el-button
                @click.prevent="doCancel()"
                slot="append"
                icon="el-icon-search"
            ></el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <!--</span>-->
    </el-dialog>
  </div>

</template>

<script>
export default {
  name: "Cancel",
  data() {
    return {
      centerDialogVisible: false,
      items:[],
      id:0,
      check_shelf_number:0,
      shelfForm: {
        shelf_number: ""
      },
      rules: {
        shelf_number: [
          {required: true, message: "请扫描货架编号", trigger: "blur"},
        ],
      },
    }
  },
  mounted() {
   var depot = this.$route.query.depot
    this.http.fetchGet(this.api.cancel+'/'+depot).then((res) => {
          var data = res.data;
          if (data.code === 200) {
            this.items = res.data.data;
          }
    }).catch((err) => {
      console.log(err);
    });
  },
  methods: {
    focus() {
      this.getInput().focus();
    },
    blur() {
      this.getInput().blur();
    },
    cancel(id,shelf_num){
      this.id = id;
      this.check_shelf_number = shelf_num;
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        this.onfocusEvent()
      })
    },
    cancelDialog() {
      this.centerDialogVisible = false
      this.shelfForm.shelf_number = ''
      this.refreshCancel()
    },
    stopKeyborad(e) {
      //尝试一下
      e.target.setAttribute('readonly', true);
      setTimeout(() => {
        e.target.removeAttribute('readonly');
      }, 100);
    },
    doCancel() {
      var _this = this;
      if(this.id == 0 || this.check_shelf_number ==0) {
        this.$message.error('系统出错，请刷新');
        return false;
      }
      this.$refs.shelfForm.validate((valid) => {
        if (valid) {
          if(this.check_shelf_number != this.shelfForm.shelf_number){
            this.$message.error(this.shelfForm.shelf_number + ' 与指定货架不一致')
            this.shelfForm.shelf_number = ''
            this.onfocusEvent()
            return false;
          }
          //作废操作
          this.http.fetchPost(this.api.doCancel, {'shelf_no':this.shelfForm.shelf_number,'id':this.id}).then((res) => {
            if(res.data.code == 200){
              this.shelfForm.shelf_number = '';
              this.centerDialogVisible = false;
              this.id = 0;
              this.$message.success('作废成功');
              setTimeout(function (){
                _this.refreshCancel()
              },500)
            }else{
              this.$message.error(res.data.message);
            }
          }).catch((err) => {
            console.log(err);
            this.shelfForm.shelf_number = ''
            this.onfocusEvent()
            this.$message.error('扫描货架号错误');
          });
        } else {
          this.$message.error('请扫描货架号');
          return false;
        }
      });


    },
    refreshCancel(){
      this.http.fetchGet(this.api.cancel).then((res) => {
        console.log(res.data)
        var data = res.data;
        if (data.code === 200) {
          this.items = res.data.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    //自动获取光标
    onfocusEvent() {
      this.$refs.shelfSearch.focus()
    },
  },
  computed: {
// 上架提示信息
    placeholderInfo() {
      return this.alter ? "扫描变更到的货架" : this.shelf_name ? "扫描货架：" + this.shelf_name : "扫描货架"
    },

  },

}
</script>

<style scoped lang="stylus">
.cancel_btn{
  width 60%;
  margin:0 20%;
  height 40px;
}
.not_click{
  background-color: #e8e8e8;
}
.status_tips{
  position: absolute;
  color: red;
  top: 2px;
  right: 17px;
  border: 1px solid red;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  border-radius: 50%;
  font-size: 28px;
}
.show {
  //float: left;
  width: 100%;

  .line {
    box-sizing: border-box;
    border: 1px solid black;
    //margin-top: 1rem;
    margin: 1px;
    //float: left;
    width: 99%;

    .el-col {
      margin-top 5px
      margin-bottom: 5px;
      padding 0 5px

      &:last-child {
        //margin-bottom: 0;
      }
    }

    .grid-content {
      //text-align center

      h3 {
        font-size 14px
      }
    }

  }
}


.old-count
  margin-left: 5px;
  width: 20px;
  height: 20px;
  background-color: #ea4444;
  line-height: 20px;
  text-align: center;
  color: white;
  border-radius: 10px

@media (max-width: 720px) {


}

</style>
